import React from 'react';
import {
  SkeletonLine,
  SkeletonCircle,
  Box,
  SkeletonRectangle,
} from '@wix/design-system';

interface NarrowSlimAppBoxSkeletonProps {
  className?: string;
}

export function RegularSlimAppBoxSkeleton({
  className,
}: NarrowSlimAppBoxSkeletonProps) {
  const showBottomSection = className?.includes('regularSlimLayout') || false;
  return (
    <Box
      className={className}
      width="100%"
      height="100%"
      direction="vertical"
      align="space-between"
    >
      <Box direction="vertical">
        <Box direction="vertical" gap="20px">
          <Box gap="12px" marginTop="2px">
            <Box flexShrink={0}>
              <SkeletonCircle diameter="50px" />
            </Box>
            <Box width="100%">
              <Box direction="vertical" gap="6px" width="100%">
                <Box>
                  <SkeletonRectangle width="100px" height="18px" />
                </Box>
                <Box direction="vertical" gap="6px">
                  <SkeletonLine width="176px" />
                  <SkeletonLine width="124px" />
                  {!showBottomSection && (
                    <Box align="space-between" verticalAlign="bottom">
                      <SkeletonLine width="80px" />
                      <SkeletonLine width="40px" />
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          {showBottomSection && (
            <Box align="space-between" verticalAlign="bottom">
              <SkeletonLine width="80px" />
              <SkeletonLine width="40px" />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
